import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { eInvitation } from '@app/signup/steps/shared/steps.model';
import { LogUser } from '@app/signup/shared/login-logout-user';

@Component({
  selector: 'error-not-match',
  templateUrl: './not-match.component.html',
  styleUrls: ['./not-match.component.scss', '../signup-errors.component.scss'],
})
export class ErrorNotMatchComponent implements OnInit {
  eInvitation = eInvitation;
  state = window['CURRENT_STATE'];
  invitation = window['INVITATION'];
  endpoints = window['ENDPOINTS'];

  constructor(private router: Router) {}

  ngOnInit() {}

  switchAccount() {
    this.router.navigate(['/change_account']);
  }

  logoutWebmail(): string {
    return `${LogUser.Urls.logoutWithLoginRedirect}&project=welcome&redirect=${encodeURIComponent(
      '/invitation/webmail'
    )}`;
  }
}
